function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import ReactDOM from 'react-dom';
function ICompress() {
  return /*#__PURE__*/React.createElement("svg", {
    "aria-hidden": "true",
    "data-rmiz-btn-unzoom-icon": true,
    fill: "currentColor",
    focusable: "false",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.144531 1.148438 L 9 6.292969 L 9 3 L 8 3 L 8 8 L 13 8 L 13 7 L 9.707031 7 L 14.855469 1.851563 Z M 8 8 L 3 8 L 3 9 L 6.292969 9 L 1.148438 14.144531 L 1.851563 14.855469 L 7 9.707031 L 7 13 L 8 13 Z"
  }));
}
function IEnlarge() {
  return /*#__PURE__*/React.createElement("svg", {
    "aria-hidden": "true",
    "data-rmiz-btn-zoom-icon": true,
    fill: "currentColor",
    focusable: "false",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 1 L 9 2 L 12.292969 2 L 2 12.292969 L 2 9 L 1 9 L 1 14 L 6 14 L 6 13 L 2.707031 13 L 13 2.707031 L 13 6 L 14 6 L 14 1 Z"
  }));
}
const testElType = (type, el) => {
  var _el$tagName, _el$tagName$toUpperCa;
  return type === (el === null || el === void 0 ? void 0 : (_el$tagName = el.tagName) === null || _el$tagName === void 0 ? void 0 : (_el$tagName$toUpperCa = _el$tagName.toUpperCase) === null || _el$tagName$toUpperCa === void 0 ? void 0 : _el$tagName$toUpperCa.call(_el$tagName));
};
const testDiv = el => testElType('DIV', el) || testElType('SPAN', el);
const testImg = el => testElType('IMG', el);
const testImgLoaded = el => el.complete && el.naturalHeight !== 0;
const testSvg = el => testElType('SVG', el);
const getScaleToWindow = _ref => {
  let height = _ref.height,
    offset = _ref.offset,
    width = _ref.width;
  return Math.min((window.innerWidth - offset * 2) / width, (window.innerHeight - offset * 2) / height);
};
const getScaleToWindowMax = _ref2 => {
  let containerHeight = _ref2.containerHeight,
    containerWidth = _ref2.containerWidth,
    offset = _ref2.offset,
    targetHeight = _ref2.targetHeight,
    targetWidth = _ref2.targetWidth;
  const scale = getScaleToWindow({
    height: targetHeight,
    offset,
    width: targetWidth
  });
  const ratio = targetWidth > targetHeight ? targetWidth / containerWidth : targetHeight / containerHeight;
  return scale > 1 ? ratio : scale * ratio;
};
const getScale = _ref3 => {
  let containerHeight = _ref3.containerHeight,
    containerWidth = _ref3.containerWidth,
    hasScalableSrc = _ref3.hasScalableSrc,
    offset = _ref3.offset,
    targetHeight = _ref3.targetHeight,
    targetWidth = _ref3.targetWidth;
  if (!containerHeight || !containerWidth) {
    return 1;
  }
  return !hasScalableSrc && targetHeight && targetWidth ? getScaleToWindowMax({
    containerHeight,
    containerWidth,
    offset,
    targetHeight,
    targetWidth
  }) : getScaleToWindow({
    height: containerHeight,
    offset,
    width: containerWidth
  });
};
const URL_REGEX = /url(?:\(['"]?)(.*?)(?:['"]?\))/;
const getImgSrc = imgEl => {
  if (imgEl) {
    if (testImg(imgEl)) {
      return imgEl.currentSrc;
    } else if (testDiv(imgEl)) {
      const bgImg = window.getComputedStyle(imgEl).backgroundImage;
      if (bgImg) {
        var _URL_REGEX$exec;
        return (_URL_REGEX$exec = URL_REGEX.exec(bgImg)) === null || _URL_REGEX$exec === void 0 ? void 0 : _URL_REGEX$exec[1];
      }
    }
  }
};
const getImgAlt = imgEl => {
  if (imgEl) {
    if (testImg(imgEl)) {
      var _imgEl$alt;
      return (_imgEl$alt = imgEl.alt) !== null && _imgEl$alt !== void 0 ? _imgEl$alt : undefined;
    } else {
      var _imgEl$getAttribute;
      return (_imgEl$getAttribute = imgEl.getAttribute('aria-label')) !== null && _imgEl$getAttribute !== void 0 ? _imgEl$getAttribute : undefined;
    }
  }
};
const getImgRegularStyle = _ref4 => {
  let containerHeight = _ref4.containerHeight,
    containerLeft = _ref4.containerLeft,
    containerTop = _ref4.containerTop,
    containerWidth = _ref4.containerWidth,
    hasScalableSrc = _ref4.hasScalableSrc,
    offset = _ref4.offset,
    targetHeight = _ref4.targetHeight,
    targetWidth = _ref4.targetWidth;
  const scale = getScale({
    containerHeight,
    containerWidth,
    hasScalableSrc,
    offset,
    targetHeight,
    targetWidth
  });
  return {
    top: containerTop,
    left: containerLeft,
    width: containerWidth * scale,
    height: containerHeight * scale,
    transform: `translate(0,0) scale(${1 / scale})`
  };
};
const parsePosition = _ref5 => {
  let position = _ref5.position,
    relativeNum = _ref5.relativeNum;
  const positionNum = parseFloat(position);
  return position.endsWith('%') ? relativeNum * positionNum / 100 : positionNum;
};
const getImgObjectFitStyle = _ref6 => {
  let containerHeight = _ref6.containerHeight,
    containerLeft = _ref6.containerLeft,
    containerTop = _ref6.containerTop,
    containerWidth = _ref6.containerWidth,
    hasScalableSrc = _ref6.hasScalableSrc,
    objectFit = _ref6.objectFit,
    objectPosition = _ref6.objectPosition,
    offset = _ref6.offset,
    targetHeight = _ref6.targetHeight,
    targetWidth = _ref6.targetWidth;
  if (objectFit === 'scale-down') {
    if (targetWidth <= containerWidth && targetHeight <= containerHeight) {
      objectFit = 'none';
    } else {
      objectFit = 'contain';
    }
  }
  if (objectFit === 'cover' || objectFit === 'contain') {
    const widthRatio = containerWidth / targetWidth;
    const heightRatio = containerHeight / targetHeight;
    const ratio = objectFit === 'cover' ? Math.max(widthRatio, heightRatio) : Math.min(widthRatio, heightRatio);
    const _objectPosition$split = objectPosition.split(' '),
      _objectPosition$split2 = _slicedToArray(_objectPosition$split, 2),
      _objectPosition$split3 = _objectPosition$split2[0],
      posLeft = _objectPosition$split3 === void 0 ? '50%' : _objectPosition$split3,
      _objectPosition$split4 = _objectPosition$split2[1],
      posTop = _objectPosition$split4 === void 0 ? '50%' : _objectPosition$split4;
    const posX = parsePosition({
      position: posLeft,
      relativeNum: containerWidth - targetWidth * ratio
    });
    const posY = parsePosition({
      position: posTop,
      relativeNum: containerHeight - targetHeight * ratio
    });
    const scale = getScale({
      containerHeight: targetHeight * ratio,
      containerWidth: targetWidth * ratio,
      hasScalableSrc,
      offset,
      targetHeight,
      targetWidth
    });
    return {
      top: containerTop + posY,
      left: containerLeft + posX,
      width: targetWidth * ratio * scale,
      height: targetHeight * ratio * scale,
      transform: `translate(0,0) scale(${1 / scale})`
    };
  } else if (objectFit === 'none') {
    const _objectPosition$split5 = objectPosition.split(' '),
      _objectPosition$split6 = _slicedToArray(_objectPosition$split5, 2),
      _objectPosition$split7 = _objectPosition$split6[0],
      posLeft = _objectPosition$split7 === void 0 ? '50%' : _objectPosition$split7,
      _objectPosition$split8 = _objectPosition$split6[1],
      posTop = _objectPosition$split8 === void 0 ? '50%' : _objectPosition$split8;
    const posX = parsePosition({
      position: posLeft,
      relativeNum: containerWidth - targetWidth
    });
    const posY = parsePosition({
      position: posTop,
      relativeNum: containerHeight - targetHeight
    });
    const scale = getScale({
      containerHeight: targetHeight,
      containerWidth: targetWidth,
      hasScalableSrc,
      offset,
      targetHeight,
      targetWidth
    });
    return {
      top: containerTop + posY,
      left: containerLeft + posX,
      width: targetWidth * scale,
      height: targetHeight * scale,
      transform: `translate(0,0) scale(${1 / scale})`
    };
  } else if (objectFit === 'fill') {
    const widthRatio = containerWidth / targetWidth;
    const heightRatio = containerHeight / targetHeight;
    const ratio = Math.max(widthRatio, heightRatio);
    const scale = getScale({
      containerHeight: targetHeight * ratio,
      containerWidth: targetWidth * ratio,
      hasScalableSrc,
      offset,
      targetHeight,
      targetWidth
    });
    return {
      width: containerWidth * scale,
      height: containerHeight * scale,
      transform: `translate(0,0) scale(${1 / scale})`
    };
  } else {
    return {};
  }
};
const getDivImgStyle = _ref7 => {
  let backgroundPosition = _ref7.backgroundPosition,
    backgroundSize = _ref7.backgroundSize,
    containerHeight = _ref7.containerHeight,
    containerLeft = _ref7.containerLeft,
    containerTop = _ref7.containerTop,
    containerWidth = _ref7.containerWidth,
    hasScalableSrc = _ref7.hasScalableSrc,
    offset = _ref7.offset,
    targetHeight = _ref7.targetHeight,
    targetWidth = _ref7.targetWidth;
  if (backgroundSize === 'cover' || backgroundSize === 'contain') {
    const widthRatio = containerWidth / targetWidth;
    const heightRatio = containerHeight / targetHeight;
    const ratio = backgroundSize === 'cover' ? Math.max(widthRatio, heightRatio) : Math.min(widthRatio, heightRatio);
    const _backgroundPosition$s = backgroundPosition.split(' '),
      _backgroundPosition$s2 = _slicedToArray(_backgroundPosition$s, 2),
      _backgroundPosition$s3 = _backgroundPosition$s2[0],
      posLeft = _backgroundPosition$s3 === void 0 ? '50%' : _backgroundPosition$s3,
      _backgroundPosition$s4 = _backgroundPosition$s2[1],
      posTop = _backgroundPosition$s4 === void 0 ? '50%' : _backgroundPosition$s4;
    const posX = parsePosition({
      position: posLeft,
      relativeNum: containerWidth - targetWidth * ratio
    });
    const posY = parsePosition({
      position: posTop,
      relativeNum: containerHeight - targetHeight * ratio
    });
    const scale = getScale({
      containerHeight: targetHeight * ratio,
      containerWidth: targetWidth * ratio,
      hasScalableSrc,
      offset,
      targetHeight,
      targetWidth
    });
    return {
      top: containerTop + posY,
      left: containerLeft + posX,
      width: targetWidth * ratio * scale,
      height: targetHeight * ratio * scale,
      transform: `translate(0,0) scale(${1 / scale})`
    };
  } else if (backgroundSize === 'auto') {
    const _backgroundPosition$s5 = backgroundPosition.split(' '),
      _backgroundPosition$s6 = _slicedToArray(_backgroundPosition$s5, 2),
      _backgroundPosition$s7 = _backgroundPosition$s6[0],
      posLeft = _backgroundPosition$s7 === void 0 ? '50%' : _backgroundPosition$s7,
      _backgroundPosition$s8 = _backgroundPosition$s6[1],
      posTop = _backgroundPosition$s8 === void 0 ? '50%' : _backgroundPosition$s8;
    const posX = parsePosition({
      position: posLeft,
      relativeNum: containerWidth - targetWidth
    });
    const posY = parsePosition({
      position: posTop,
      relativeNum: containerHeight - targetHeight
    });
    const scale = getScale({
      containerHeight: targetHeight,
      containerWidth: targetWidth,
      hasScalableSrc,
      offset,
      targetHeight,
      targetWidth
    });
    return {
      top: containerTop + posY,
      left: containerLeft + posX,
      width: targetWidth * scale,
      height: targetHeight * scale,
      transform: `translate(0,0) scale(${1 / scale})`
    };
  } else {
    const _backgroundSize$split = backgroundSize.split(' '),
      _backgroundSize$split2 = _slicedToArray(_backgroundSize$split, 2),
      _backgroundSize$split3 = _backgroundSize$split2[0],
      sizeW = _backgroundSize$split3 === void 0 ? '50%' : _backgroundSize$split3,
      _backgroundSize$split4 = _backgroundSize$split2[1],
      sizeH = _backgroundSize$split4 === void 0 ? '50%' : _backgroundSize$split4;
    const sizeWidth = parsePosition({
      position: sizeW,
      relativeNum: containerWidth
    });
    const sizeHeight = parsePosition({
      position: sizeH,
      relativeNum: containerHeight
    });
    const widthRatio = sizeWidth / targetWidth;
    const heightRatio = sizeHeight / targetHeight;
    const ratio = Math.min(widthRatio, heightRatio);
    const _backgroundPosition$s9 = backgroundPosition.split(' '),
      _backgroundPosition$s10 = _slicedToArray(_backgroundPosition$s9, 2),
      _backgroundPosition$s11 = _backgroundPosition$s10[0],
      posLeft = _backgroundPosition$s11 === void 0 ? '50%' : _backgroundPosition$s11,
      _backgroundPosition$s12 = _backgroundPosition$s10[1],
      posTop = _backgroundPosition$s12 === void 0 ? '50%' : _backgroundPosition$s12;
    const posX = parsePosition({
      position: posLeft,
      relativeNum: containerWidth - targetWidth * ratio
    });
    const posY = parsePosition({
      position: posTop,
      relativeNum: containerHeight - targetHeight * ratio
    });
    const scale = getScale({
      containerHeight: targetHeight * ratio,
      containerWidth: targetWidth * ratio,
      hasScalableSrc,
      offset,
      targetHeight,
      targetWidth
    });
    return {
      top: containerTop + posY,
      left: containerLeft + posX,
      width: targetWidth * ratio * scale,
      height: targetHeight * ratio * scale,
      transform: `translate(0,0) scale(${1 / scale})`
    };
  }
};
const SRC_SVG_REGEX = /\.svg$/i;
const getStyleModalImg = _ref8 => {
  var _imgSrc$slice;
  let hasZoomImg = _ref8.hasZoomImg,
    imgSrc = _ref8.imgSrc,
    isSvg = _ref8.isSvg,
    isZoomed = _ref8.isZoomed,
    loadedImgEl = _ref8.loadedImgEl,
    offset = _ref8.offset,
    shouldRefresh = _ref8.shouldRefresh,
    targetEl = _ref8.targetEl;
  const hasScalableSrc = isSvg || (imgSrc === null || imgSrc === void 0 ? void 0 : (_imgSrc$slice = imgSrc.slice) === null || _imgSrc$slice === void 0 ? void 0 : _imgSrc$slice.call(imgSrc, 0, 18)) === 'data:image/svg+xml' || hasZoomImg || !!(imgSrc && SRC_SVG_REGEX.test(imgSrc));
  const imgRect = targetEl.getBoundingClientRect();
  const targetElComputedStyle = window.getComputedStyle(targetEl);
  const isDivImg = loadedImgEl != null && testDiv(targetEl);
  const isImgObjectFit = loadedImgEl != null && !isDivImg;
  const styleImgRegular = getImgRegularStyle({
    containerHeight: imgRect.height,
    containerLeft: imgRect.left,
    containerTop: imgRect.top,
    containerWidth: imgRect.width,
    hasScalableSrc,
    offset,
    targetHeight: (loadedImgEl === null || loadedImgEl === void 0 ? void 0 : loadedImgEl.naturalHeight) || imgRect.height,
    targetWidth: (loadedImgEl === null || loadedImgEl === void 0 ? void 0 : loadedImgEl.naturalWidth) || imgRect.width
  });
  const styleImgObjectFit = isImgObjectFit ? getImgObjectFitStyle({
    containerHeight: imgRect.height,
    containerLeft: imgRect.left,
    containerTop: imgRect.top,
    containerWidth: imgRect.width,
    hasScalableSrc,
    objectFit: targetElComputedStyle.objectFit,
    objectPosition: targetElComputedStyle.objectPosition,
    offset,
    targetHeight: (loadedImgEl === null || loadedImgEl === void 0 ? void 0 : loadedImgEl.naturalHeight) || imgRect.height,
    targetWidth: (loadedImgEl === null || loadedImgEl === void 0 ? void 0 : loadedImgEl.naturalWidth) || imgRect.width
  }) : undefined;
  const styleDivImg = isDivImg ? getDivImgStyle({
    backgroundPosition: targetElComputedStyle.backgroundPosition,
    backgroundSize: targetElComputedStyle.backgroundSize,
    containerHeight: imgRect.height,
    containerLeft: imgRect.left,
    containerTop: imgRect.top,
    containerWidth: imgRect.width,
    hasScalableSrc,
    offset,
    targetHeight: (loadedImgEl === null || loadedImgEl === void 0 ? void 0 : loadedImgEl.naturalHeight) || imgRect.height,
    targetWidth: (loadedImgEl === null || loadedImgEl === void 0 ? void 0 : loadedImgEl.naturalWidth) || imgRect.width
  }) : undefined;
  const style = Object.assign({}, styleImgRegular, styleImgObjectFit, styleDivImg);
  if (isZoomed) {
    const viewportX = window.innerWidth / 2;
    const viewportY = window.innerHeight / 2;
    const childCenterX = parseFloat(String(style.left || 0)) + parseFloat(String(style.width || 0)) / 2;
    const childCenterY = parseFloat(String(style.top || 0)) + parseFloat(String(style.height || 0)) / 2;
    const translateX = viewportX - childCenterX;
    const translateY = viewportY - childCenterY;
    if (shouldRefresh) {
      style.transitionDuration = '0.01ms';
    }
    style.transform = `translate(${translateX}px,${translateY}px) scale(1)`;
  }
  return style;
};
const getStyleGhost = imgEl => {
  if (!imgEl) {
    return {};
  }
  if (testSvg(imgEl)) {
    const parentEl = imgEl.parentElement;
    const rect = imgEl.getBoundingClientRect();
    if (parentEl) {
      const parentRect = parentEl.getBoundingClientRect();
      return {
        height: rect.height,
        left: parentRect.left - rect.left,
        top: parentRect.top - rect.top,
        width: rect.width
      };
    } else {
      return {
        height: rect.height,
        left: rect.left,
        width: rect.width,
        top: rect.top
      };
    }
  } else {
    return {
      height: imgEl.offsetHeight,
      left: imgEl.offsetLeft,
      width: imgEl.offsetWidth,
      top: imgEl.offsetTop
    };
  }
};
const adjustSvgIDs = svgEl => {
  const newIdSuffix = '-zoom';
  const attrs = ['clip-path', 'fill', 'mask', 'marker-start', 'marker-mid', 'marker-end'];
  const idMap = new Map();
  if (svgEl.hasAttribute('id')) {
    const oldId = svgEl.id;
    const newId = oldId + newIdSuffix;
    idMap.set(oldId, newId);
    svgEl.id = newId;
  }
  svgEl.querySelectorAll('[id]').forEach(el => {
    const oldId = el.id;
    const newId = oldId + newIdSuffix;
    idMap.set(oldId, newId);
    el.id = newId;
  });
  idMap.forEach((newId, oldId) => {
    const urlOldID = `url(#${oldId})`;
    const urlNewID = `url(#${newId})`;
    const attrsQuery = attrs.map(attr => `[${attr}="${urlOldID}"]`).join(', ');
    svgEl.querySelectorAll(attrsQuery).forEach(usedEl => {
      attrs.forEach(attr => {
        if (usedEl.getAttribute(attr) === urlOldID) {
          usedEl.setAttribute(attr, urlNewID);
        }
      });
    });
  });
  svgEl.querySelectorAll('style').forEach(styleEl => {
    idMap.forEach((newId, oldId) => {
      if (styleEl.textContent) {
        styleEl.textContent = styleEl.textContent.replaceAll(`#${oldId}`, `#${newId}`);
      }
    });
  });
};
const IMAGE_QUERY = ['img', 'svg', '[role="img"]', '[data-zoom]'].map(x => `${x}:not([aria-hidden="true"])`).join(',');
const defaultBodyAttrs = {
  overflow: '',
  width: ''
};
function Controlled(props) {
  return /*#__PURE__*/React.createElement(ControlledBase, _objectSpread({}, props));
}
class ControlledBase extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      id: '',
      isZoomImgLoaded: false,
      loadedImgEl: undefined,
      modalState: "UNLOADED",
      shouldRefresh: false,
      styleGhost: {}
    };
    this.refContent = /*#__PURE__*/React.createRef();
    this.refDialog = /*#__PURE__*/React.createRef();
    this.refModalContent = /*#__PURE__*/React.createRef();
    this.refModalImg = /*#__PURE__*/React.createRef();
    this.refWrap = /*#__PURE__*/React.createRef();
    this.imgEl = null;
    this.isScaling = false;
    this.prevBodyAttrs = defaultBodyAttrs;
    this.styleModalImg = {};
    this.getDialogContainer = () => {
      let el = document.querySelector('[data-rmiz-portal]');
      if (el == null) {
        el = document.createElement('div');
        el.setAttribute('data-rmiz-portal', '');
        document.body.appendChild(el);
      }
      return el;
    };
    this.setId = () => {
      const gen4 = () => Math.random().toString(16).slice(-4);
      this.setState({
        id: gen4() + gen4() + gen4()
      });
    };
    this.setAndTrackImg = () => {
      const contentEl = this.refContent.current;
      if (!contentEl) return;
      this.imgEl = contentEl.querySelector(IMAGE_QUERY);
      if (this.imgEl) {
        var _this$contentNotFound, _this$contentNotFound2;
        (_this$contentNotFound = this.contentNotFoundChangeObserver) === null || _this$contentNotFound === void 0 ? void 0 : (_this$contentNotFound2 = _this$contentNotFound.disconnect) === null || _this$contentNotFound2 === void 0 ? void 0 : _this$contentNotFound2.call(_this$contentNotFound);
        this.imgEl.addEventListener('load', this.handleImgLoad);
        this.imgEl.addEventListener('click', this.handleZoom);
        if (!this.state.loadedImgEl) {
          this.handleImgLoad();
        }
        this.imgElResizeObserver = new ResizeObserver(entries => {
          const entry = entries[0];
          if (entry !== null && entry !== void 0 && entry.target) {
            this.imgEl = entry.target;
            this.setState({
              styleGhost: getStyleGhost(this.imgEl)
            });
          }
        });
        this.imgElResizeObserver.observe(this.imgEl);
        if (!this.contentChangeObserver) {
          this.contentChangeObserver = new MutationObserver(() => {
            this.setState({
              styleGhost: getStyleGhost(this.imgEl)
            });
          });
          this.contentChangeObserver.observe(contentEl, {
            attributes: true,
            childList: true,
            subtree: true
          });
        }
      } else if (!this.contentNotFoundChangeObserver) {
        this.contentNotFoundChangeObserver = new MutationObserver(this.setAndTrackImg);
        this.contentNotFoundChangeObserver.observe(contentEl, {
          childList: true,
          subtree: true
        });
      }
    };
    this.handleIfZoomChanged = prevIsZoomed => {
      const isZoomed = this.props.isZoomed;
      if (!prevIsZoomed && isZoomed) {
        this.zoom();
      } else if (prevIsZoomed && !isZoomed) {
        this.unzoom();
      }
    };
    this.handleImgLoad = () => {
      const imgSrc = getImgSrc(this.imgEl);
      if (!imgSrc) return;
      const img = new Image();
      if (testImg(this.imgEl)) {
        img.sizes = this.imgEl.sizes;
        img.srcset = this.imgEl.srcset;
      }
      img.src = imgSrc;
      const setLoaded = () => {
        this.setState({
          loadedImgEl: img,
          styleGhost: getStyleGhost(this.imgEl)
        });
      };
      img.decode().then(setLoaded).catch(() => {
        if (testImgLoaded(img)) {
          setLoaded();
          return;
        }
        img.onload = setLoaded;
      });
    };
    this.handleZoom = () => {
      if (this.hasImage()) {
        var _this$props$onZoomCha, _this$props;
        (_this$props$onZoomCha = (_this$props = this.props).onZoomChange) === null || _this$props$onZoomCha === void 0 ? void 0 : _this$props$onZoomCha.call(_this$props, true);
      }
    };
    this.handleUnzoom = () => {
      var _this$props$onZoomCha2, _this$props2;
      (_this$props$onZoomCha2 = (_this$props2 = this.props).onZoomChange) === null || _this$props$onZoomCha2 === void 0 ? void 0 : _this$props$onZoomCha2.call(_this$props2, false);
    };
    this.handleDialogCancel = e => {
      e.preventDefault();
    };
    this.handleDialogClick = e => {
      if (e.target === this.refModalContent.current || e.target === this.refModalImg.current) {
        this.handleUnzoom();
      }
    };
    this.handleKeyDown = e => {
      if (e.key === 'Escape' || e.keyCode === 27) {
        e.preventDefault();
        e.stopPropagation();
        this.handleUnzoom();
      }
    };
    this.handleWheel = e => {
      if (e.ctrlKey) return;
      e.stopPropagation();
      queueMicrotask(() => {
        this.handleUnzoom();
      });
    };
    this.handleTouchStart = e => {
      if (e.touches.length > 1) {
        this.isScaling = true;
        return;
      }
      if (e.changedTouches.length === 1 && e.changedTouches[0]) {
        this.touchYStart = e.changedTouches[0].screenY;
      }
    };
    this.handleTouchMove = e => {
      var _window$visualViewpor, _window$visualViewpor2;
      const browserScale = (_window$visualViewpor = (_window$visualViewpor2 = window.visualViewport) === null || _window$visualViewpor2 === void 0 ? void 0 : _window$visualViewpor2.scale) !== null && _window$visualViewpor !== void 0 ? _window$visualViewpor : 1;
      if (this.props.canSwipeToUnzoom && !this.isScaling && browserScale <= 1 && this.touchYStart != null && e.changedTouches[0]) {
        this.touchYEnd = e.changedTouches[0].screenY;
        const max = Math.max(this.touchYStart, this.touchYEnd);
        const min = Math.min(this.touchYStart, this.touchYEnd);
        const delta = Math.abs(max - min);
        if (delta > this.props.swipeToUnzoomThreshold) {
          this.touchYStart = undefined;
          this.touchYEnd = undefined;
          this.handleUnzoom();
        }
      }
    };
    this.handleTouchEnd = () => {
      this.isScaling = false;
      this.touchYStart = undefined;
      this.touchYEnd = undefined;
    };
    this.handleTouchCancel = () => {
      this.isScaling = false;
      this.touchYStart = undefined;
      this.touchYEnd = undefined;
    };
    this.handleResize = () => {
      this.setState({
        shouldRefresh: true
      });
    };
    this.hasImage = () => {
      return this.imgEl && (this.state.loadedImgEl || testSvg(this.imgEl)) && window.getComputedStyle(this.imgEl).display !== 'none';
    };
    this.zoom = () => {
      var _this$refDialog$curre, _this$refDialog$curre2, _this$refModalImg$cur, _this$refModalImg$cur2;
      this.bodyScrollDisable();
      (_this$refDialog$curre = this.refDialog.current) === null || _this$refDialog$curre === void 0 ? void 0 : (_this$refDialog$curre2 = _this$refDialog$curre.showModal) === null || _this$refDialog$curre2 === void 0 ? void 0 : _this$refDialog$curre2.call(_this$refDialog$curre);
      this.setState({
        modalState: "LOADING"
      });
      this.loadZoomImg();
      window.addEventListener('touchstart', this.handleTouchStart, {
        passive: true
      });
      window.addEventListener('touchmove', this.handleTouchMove, {
        passive: true
      });
      window.addEventListener('touchend', this.handleTouchEnd, {
        passive: true
      });
      window.addEventListener('touchcancel', this.handleTouchCancel, {
        passive: true
      });
      document.addEventListener('keydown', this.handleKeyDown, true);
      (_this$refModalImg$cur = this.refModalImg.current) === null || _this$refModalImg$cur === void 0 ? void 0 : (_this$refModalImg$cur2 = _this$refModalImg$cur.addEventListener) === null || _this$refModalImg$cur2 === void 0 ? void 0 : _this$refModalImg$cur2.call(_this$refModalImg$cur, 'transitionend', this.handleZoomEnd, {
        once: true
      });
    };
    this.handleZoomEnd = () => {
      setTimeout(() => {
        this.setState({
          modalState: "LOADED"
        });
        window.addEventListener('resize', this.handleResize, {
          passive: true
        });
        window.addEventListener('wheel', this.handleWheel, {
          passive: true
        });
      }, 0);
    };
    this.unzoom = () => {
      var _this$refModalImg$cur3, _this$refModalImg$cur4;
      this.setState({
        modalState: "UNLOADING"
      });
      window.removeEventListener('wheel', this.handleWheel);
      window.removeEventListener('touchstart', this.handleTouchStart);
      window.removeEventListener('touchmove', this.handleTouchMove);
      window.removeEventListener('touchend', this.handleTouchEnd);
      window.removeEventListener('touchcancel', this.handleTouchCancel);
      document.removeEventListener('keydown', this.handleKeyDown, true);
      (_this$refModalImg$cur3 = this.refModalImg.current) === null || _this$refModalImg$cur3 === void 0 ? void 0 : (_this$refModalImg$cur4 = _this$refModalImg$cur3.addEventListener) === null || _this$refModalImg$cur4 === void 0 ? void 0 : _this$refModalImg$cur4.call(_this$refModalImg$cur3, 'transitionend', this.handleUnzoomEnd, {
        once: true
      });
    };
    this.handleUnzoomEnd = () => {
      setTimeout(() => {
        window.removeEventListener('resize', this.handleResize);
        this.setState({
          shouldRefresh: false,
          modalState: "UNLOADED"
        }, () => {
          var _this$refDialog$curre3, _this$refDialog$curre4;
          (_this$refDialog$curre3 = this.refDialog.current) === null || _this$refDialog$curre3 === void 0 ? void 0 : (_this$refDialog$curre4 = _this$refDialog$curre3.close) === null || _this$refDialog$curre4 === void 0 ? void 0 : _this$refDialog$curre4.call(_this$refDialog$curre3);
          this.bodyScrollEnable();
        });
      }, 0);
    };
    this.bodyScrollDisable = () => {
      this.prevBodyAttrs = {
        overflow: document.body.style.overflow,
        width: document.body.style.width
      };
      const clientWidth = document.body.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.width = `${clientWidth}px`;
    };
    this.bodyScrollEnable = () => {
      document.body.style.width = this.prevBodyAttrs.width;
      document.body.style.overflow = this.prevBodyAttrs.overflow;
      this.prevBodyAttrs = defaultBodyAttrs;
    };
    this.loadZoomImg = () => {
      const zoomImg = this.props.zoomImg;
      const zoomImgSrc = zoomImg === null || zoomImg === void 0 ? void 0 : zoomImg.src;
      if (zoomImgSrc) {
        var _zoomImg$sizes, _zoomImg$srcSet;
        const img = new Image();
        img.sizes = (_zoomImg$sizes = zoomImg === null || zoomImg === void 0 ? void 0 : zoomImg.sizes) !== null && _zoomImg$sizes !== void 0 ? _zoomImg$sizes : '';
        img.srcset = (_zoomImg$srcSet = zoomImg === null || zoomImg === void 0 ? void 0 : zoomImg.srcSet) !== null && _zoomImg$srcSet !== void 0 ? _zoomImg$srcSet : '';
        img.src = zoomImgSrc;
        const setLoaded = () => {
          this.setState({
            isZoomImgLoaded: true
          });
        };
        img.decode().then(setLoaded).catch(() => {
          if (testImgLoaded(img)) {
            setLoaded();
            return;
          }
          img.onload = setLoaded;
        });
      }
    };
    this.UNSAFE_handleSvg = () => {
      const imgEl = this.imgEl,
        refModalImg = this.refModalImg,
        styleModalImg = this.styleModalImg;
      if (testSvg(imgEl)) {
        var _refModalImg$current, _refModalImg$current$, _refModalImg$current$2, _refModalImg$current2, _refModalImg$current3;
        const svgEl = imgEl.cloneNode(true);
        adjustSvgIDs(svgEl);
        svgEl.style.width = `${styleModalImg.width || 0}px`;
        svgEl.style.height = `${styleModalImg.height || 0}px`;
        svgEl.addEventListener('click', this.handleUnzoom);
        (_refModalImg$current = refModalImg.current) === null || _refModalImg$current === void 0 ? void 0 : (_refModalImg$current$ = _refModalImg$current.firstChild) === null || _refModalImg$current$ === void 0 ? void 0 : (_refModalImg$current$2 = _refModalImg$current$.remove) === null || _refModalImg$current$2 === void 0 ? void 0 : _refModalImg$current$2.call(_refModalImg$current$);
        (_refModalImg$current2 = refModalImg.current) === null || _refModalImg$current2 === void 0 ? void 0 : (_refModalImg$current3 = _refModalImg$current2.appendChild) === null || _refModalImg$current3 === void 0 ? void 0 : _refModalImg$current3.call(_refModalImg$current2, svgEl);
      }
    };
  }
  render() {
    const handleDialogCancel = this.handleDialogCancel,
      handleDialogClick = this.handleDialogClick,
      handleUnzoom = this.handleUnzoom,
      handleZoom = this.handleZoom,
      imgEl = this.imgEl,
      _this$props3 = this.props,
      a11yNameButtonUnzoom = _this$props3.a11yNameButtonUnzoom,
      a11yNameButtonZoom = _this$props3.a11yNameButtonZoom,
      children = _this$props3.children,
      classDialog = _this$props3.classDialog,
      IconUnzoom = _this$props3.IconUnzoom,
      IconZoom = _this$props3.IconZoom,
      isZoomed = _this$props3.isZoomed,
      WrapElement = _this$props3.wrapElement,
      ZoomContent = _this$props3.ZoomContent,
      zoomImg = _this$props3.zoomImg,
      zoomMargin = _this$props3.zoomMargin,
      refContent = this.refContent,
      refDialog = this.refDialog,
      refModalContent = this.refModalContent,
      refModalImg = this.refModalImg,
      refWrap = this.refWrap,
      _this$state = this.state,
      id = _this$state.id,
      isZoomImgLoaded = _this$state.isZoomImgLoaded,
      loadedImgEl = _this$state.loadedImgEl,
      modalState = _this$state.modalState,
      shouldRefresh = _this$state.shouldRefresh,
      styleGhost = _this$state.styleGhost;
    const idModal = `rmiz-modal-${id}`;
    const idModalImg = `rmiz-modal-img-${id}`;
    const isDiv = testDiv(imgEl);
    const isImg = testImg(imgEl);
    const isSvg = testSvg(imgEl);
    const imgAlt = getImgAlt(imgEl);
    const imgSrc = getImgSrc(imgEl);
    const imgSizes = isImg ? imgEl.sizes : undefined;
    const imgSrcSet = isImg ? imgEl.srcset : undefined;
    const hasZoomImg = !!(zoomImg !== null && zoomImg !== void 0 && zoomImg.src);
    const hasImage = this.hasImage();
    const labelBtnZoom = imgAlt ? `${a11yNameButtonZoom}: ${imgAlt}` : a11yNameButtonZoom;
    const isModalActive = modalState === "LOADING" || modalState === "LOADED";
    const dataContentState = hasImage ? 'found' : 'not-found';
    const dataOverlayState = modalState === "UNLOADED" || modalState === "UNLOADING" ? 'hidden' : 'visible';
    const styleContent = {
      visibility: modalState === "UNLOADED" ? 'visible' : 'hidden'
    };
    this.styleModalImg = hasImage ? getStyleModalImg({
      hasZoomImg,
      imgSrc,
      isSvg,
      isZoomed: isZoomed && isModalActive,
      loadedImgEl,
      offset: zoomMargin,
      shouldRefresh,
      targetEl: imgEl
    }) : {};
    let modalContent = null;
    if (hasImage) {
      const modalImg = isImg || isDiv ? /*#__PURE__*/React.createElement("img", _objectSpread(_objectSpread({
        alt: imgAlt,
        sizes: imgSizes,
        src: imgSrc,
        srcSet: imgSrcSet
      }, isZoomImgLoaded && modalState === "LOADED" ? zoomImg : {}), {}, {
        "data-rmiz-modal-img": "",
        height: this.styleModalImg.height || undefined,
        id: idModalImg,
        ref: refModalImg,
        style: this.styleModalImg,
        width: this.styleModalImg.width || undefined
      })) : isSvg ? /*#__PURE__*/React.createElement("div", {
        "data-rmiz-modal-img": true,
        ref: refModalImg,
        style: this.styleModalImg
      }) : null;
      const modalBtnUnzoom = /*#__PURE__*/React.createElement("button", {
        "aria-label": a11yNameButtonUnzoom,
        "data-rmiz-btn-unzoom": "",
        onClick: handleUnzoom,
        type: "button"
      }, /*#__PURE__*/React.createElement(IconUnzoom, null));
      modalContent = ZoomContent ? /*#__PURE__*/React.createElement(ZoomContent, {
        buttonUnzoom: modalBtnUnzoom,
        modalState: modalState,
        img: modalImg,
        onUnzoom: handleUnzoom
      }) : /*#__PURE__*/React.createElement(React.Fragment, null, modalImg, modalBtnUnzoom);
    }
    return /*#__PURE__*/React.createElement(WrapElement, {
      "aria-owns": idModal,
      "data-rmiz": "",
      ref: refWrap
    }, /*#__PURE__*/React.createElement(WrapElement, {
      "data-rmiz-content": dataContentState,
      ref: refContent,
      style: styleContent
    }, children), hasImage && /*#__PURE__*/React.createElement(WrapElement, {
      "data-rmiz-ghost": "",
      style: styleGhost
    }, /*#__PURE__*/React.createElement("button", {
      "aria-label": labelBtnZoom,
      "data-rmiz-btn-zoom": "",
      onClick: handleZoom,
      type: "button"
    }, /*#__PURE__*/React.createElement(IconZoom, null))), hasImage && /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("dialog", {
      "aria-labelledby": idModalImg,
      "aria-modal": "true",
      className: classDialog,
      "data-rmiz-modal": "",
      id: idModal,
      onClick: handleDialogClick,
      onClose: handleUnzoom,
      onCancel: handleDialogCancel,
      ref: refDialog,
      role: "dialog"
    }, /*#__PURE__*/React.createElement("div", {
      "data-rmiz-modal-overlay": dataOverlayState
    }), /*#__PURE__*/React.createElement("div", {
      "data-rmiz-modal-content": "",
      ref: refModalContent
    }, modalContent)), this.getDialogContainer()));
  }
  componentDidMount() {
    this.setId();
    this.setAndTrackImg();
    this.handleImgLoad();
    this.UNSAFE_handleSvg();
  }
  componentWillUnmount() {
    var _this$contentChangeOb, _this$contentChangeOb2, _this$contentNotFound3, _this$contentNotFound4, _this$imgElResizeObse, _this$imgElResizeObse2, _this$imgEl, _this$imgEl$removeEve, _this$imgEl2, _this$imgEl2$removeEv, _this$refModalImg$cur5, _this$refModalImg$cur6, _this$refModalImg$cur7, _this$refModalImg$cur8;
    if (this.state.modalState !== "UNLOADED") {
      this.bodyScrollEnable();
    }
    (_this$contentChangeOb = this.contentChangeObserver) === null || _this$contentChangeOb === void 0 ? void 0 : (_this$contentChangeOb2 = _this$contentChangeOb.disconnect) === null || _this$contentChangeOb2 === void 0 ? void 0 : _this$contentChangeOb2.call(_this$contentChangeOb);
    (_this$contentNotFound3 = this.contentNotFoundChangeObserver) === null || _this$contentNotFound3 === void 0 ? void 0 : (_this$contentNotFound4 = _this$contentNotFound3.disconnect) === null || _this$contentNotFound4 === void 0 ? void 0 : _this$contentNotFound4.call(_this$contentNotFound3);
    (_this$imgElResizeObse = this.imgElResizeObserver) === null || _this$imgElResizeObse === void 0 ? void 0 : (_this$imgElResizeObse2 = _this$imgElResizeObse.disconnect) === null || _this$imgElResizeObse2 === void 0 ? void 0 : _this$imgElResizeObse2.call(_this$imgElResizeObse);
    (_this$imgEl = this.imgEl) === null || _this$imgEl === void 0 ? void 0 : (_this$imgEl$removeEve = _this$imgEl.removeEventListener) === null || _this$imgEl$removeEve === void 0 ? void 0 : _this$imgEl$removeEve.call(_this$imgEl, 'load', this.handleImgLoad);
    (_this$imgEl2 = this.imgEl) === null || _this$imgEl2 === void 0 ? void 0 : (_this$imgEl2$removeEv = _this$imgEl2.removeEventListener) === null || _this$imgEl2$removeEv === void 0 ? void 0 : _this$imgEl2$removeEv.call(_this$imgEl2, 'click', this.handleZoom);
    (_this$refModalImg$cur5 = this.refModalImg.current) === null || _this$refModalImg$cur5 === void 0 ? void 0 : (_this$refModalImg$cur6 = _this$refModalImg$cur5.removeEventListener) === null || _this$refModalImg$cur6 === void 0 ? void 0 : _this$refModalImg$cur6.call(_this$refModalImg$cur5, 'transitionend', this.handleZoomEnd);
    (_this$refModalImg$cur7 = this.refModalImg.current) === null || _this$refModalImg$cur7 === void 0 ? void 0 : (_this$refModalImg$cur8 = _this$refModalImg$cur7.removeEventListener) === null || _this$refModalImg$cur8 === void 0 ? void 0 : _this$refModalImg$cur8.call(_this$refModalImg$cur7, 'transitionend', this.handleUnzoomEnd);
    window.removeEventListener('wheel', this.handleWheel);
    window.removeEventListener('touchstart', this.handleTouchStart);
    window.removeEventListener('touchmove', this.handleTouchMove);
    window.removeEventListener('touchend', this.handleTouchEnd);
    window.removeEventListener('touchcancel', this.handleTouchCancel);
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('keydown', this.handleKeyDown, true);
  }
  componentDidUpdate(prevProps) {
    this.UNSAFE_handleSvg();
    this.handleIfZoomChanged(prevProps.isZoomed);
  }
}
ControlledBase.defaultProps = {
  a11yNameButtonUnzoom: 'Minimize image',
  a11yNameButtonZoom: 'Expand image',
  canSwipeToUnzoom: true,
  IconUnzoom: ICompress,
  IconZoom: IEnlarge,
  swipeToUnzoomThreshold: 10,
  wrapElement: 'div',
  zoomMargin: 0
};
function Uncontrolled(props) {
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isZoomed = _React$useState2[0],
    setIsZoomed = _React$useState2[1];
  return /*#__PURE__*/React.createElement(Controlled, _objectSpread(_objectSpread({}, props), {}, {
    isZoomed: isZoomed,
    onZoomChange: setIsZoomed
  }));
}
export { Controlled, Uncontrolled as default };